// Publications dataset. Filterable by year, type, domain.
export const PUBLICATION_TYPES = ["Journal", "Conference", "White Paper", "Patent"];
export const PUBLICATION_DOMAINS = ["AI-Embedded Devices", "Robotics", "Medical Device", "HCI"];

export const PUBLICATIONS = [
  {
    id: "P-2025-014",
    year: 2025,
    type: "Journal",
    domain: "AI-Embedded Devices",
    venue: "ACM CHI",
    citation: "Park, J., Kim, S., Lee, H. (2025). Calibrating clinician trust in diagnostic copilots: counterfactual UI patterns reduce automation bias. ACM CHI 2025.",
    citation_ko: "박지원, 김선우, 이혜진 (2025). 진단 보조 AI에 대한 임상의 신뢰 보정: 반사실 UI 패턴이 자동화 편향을 감소시킨다. ACM CHI 2025.",
    title: "Calibrating Clinician Trust in Diagnostic Copilots",
    title_ko: "진단 보조 AI에 대한 임상의 신뢰 보정",
    url: "#",
  },
  {
    id: "P-2025-009",
    year: 2025,
    type: "Conference",
    domain: "Robotics",
    venue: "IEEE ICRA",
    citation: "Lee, H., Cho, M. (2025). Foot-pedal remapping and surgeon fatigue: a multi-site EMG study of telesurgery consoles. IEEE ICRA 2025.",
    citation_ko: "이혜진, 조민혁 (2025). 풋페달 재매핑과 외과의 피로도: 원격수술 콘솔의 다중 사이트 EMG 연구. IEEE ICRA 2025.",
    title: "Foot-Pedal Remapping and Surgeon Fatigue",
    title_ko: "풋페달 재매핑과 외과의 피로도",
    url: "#",
  },
  {
    id: "P-2024-022",
    year: 2024,
    type: "Journal",
    domain: "Medical Device",
    venue: "Applied Ergonomics",
    citation: "Han, B., Park, J. (2024). Summative human factors validation of smart infusion pumps: a multi-site simulation study. Applied Ergonomics 117.",
    citation_ko: "한병주, 박지원 (2024). 스마트 수액 펌프의 총괄 인간요인 검증: 다중 사이트 시뮬레이션 연구. Applied Ergonomics 117.",
    title: "Summative HFE Validation of Smart Infusion Pumps",
    title_ko: "스마트 수액 펌프의 총괄 HFE 검증",
    url: "#",
  },
  {
    id: "P-2024-018",
    year: 2024,
    type: "White Paper",
    domain: "HCI",
    venue: "CATT Technical Report",
    citation: "CATT (2024). Measuring cognitive load in safety-critical UIs: a practitioner's guide. CATT TR-2024-08.",
    citation_ko: "CATT (2024). 안전 필수 UI의 인지 부하 측정: 실무자 가이드. CATT TR-2024-08.",
    title: "Measuring Cognitive Load in Safety-Critical UIs",
    title_ko: "안전 필수 UI의 인지 부하 측정",
    url: "#",
  },
  {
    id: "P-2024-005",
    year: 2024,
    type: "Conference",
    domain: "AI-Embedded Devices",
    venue: "ACM CSCW",
    citation: "Kim, S., Lee, H. (2024). Verbal protocol analysis of radiologist-AI co-reading. ACM CSCW 2024.",
    citation_ko: "김선우, 이혜진 (2024). 영상의-AI 협동 판독의 발화 프로토콜 분석. ACM CSCW 2024.",
    title: "Verbal Protocol Analysis of Radiologist-AI Co-Reading",
    title_ko: "영상의-AI 협동 판독의 발화 프로토콜 분석",
    url: "#",
  },
  {
    id: "P-2023-031",
    year: 2023,
    type: "Patent",
    domain: "Medical Device",
    venue: "USPTO 11,xxx,xxx",
    citation: "CATT & Partner (2023). Method and system for adaptive alarm prioritisation in clinical infusion devices. US Patent.",
    citation_ko: "CATT 외 (2023). 임상 주입기의 적응형 알람 우선순위 결정 방법 및 시스템. 미국 특허.",
    title: "Adaptive Alarm Prioritisation in Clinical Infusion",
    title_ko: "임상 주입기의 적응형 알람 우선순위 결정",
    url: "#",
  },
  {
    id: "P-2023-019",
    year: 2023,
    type: "Journal",
    domain: "Robotics",
    venue: "Human Factors",
    citation: "Cho, M., Park, J. (2023). Intent legibility in collaborative robotic arms: an eye-tracking study. Human Factors 65(4).",
    citation_ko: "조민혁, 박지원 (2023). 협동 로봇팔의 의도 가독성: 아이트래킹 연구. Human Factors 65(4).",
    title: "Intent Legibility in Collaborative Robotic Arms",
    title_ko: "협동 로봇팔의 의도 가독성",
    url: "#",
  },
  {
    id: "P-2023-007",
    year: 2023,
    type: "Conference",
    domain: "HCI",
    venue: "ACM UIST",
    citation: "Lee, H., Han, B. (2023). Embodied feedback for surgical telemanipulation. ACM UIST 2023.",
    citation_ko: "이혜진, 한병주 (2023). 수술 원격조작을 위한 체화된 피드백. ACM UIST 2023.",
    title: "Embodied Feedback for Surgical Telemanipulation",
    title_ko: "수술 원격조작을 위한 체화된 피드백",
    url: "#",
  },
  {
    id: "P-2022-026",
    year: 2022,
    type: "Journal",
    domain: "AI Systems",
    venue: "International Journal of HCI",
    citation: "Park, J., Kim, S. (2022). Trust dynamics in human-LLM clinical conversations: a longitudinal study. IJHCI 38(11).",
    citation_ko: "박지원, 김선우 (2022). 휴먼-LLM 임상 대화에서의 신뢰 역학: 종단 연구. IJHCI 38(11).",
    title: "Trust Dynamics in Human-LLM Clinical Conversations",
    title_ko: "휴먼-LLM 임상 대화에서의 신뢰 역학",
    url: "#",
  },
  {
    id: "P-2022-011",
    year: 2022,
    type: "White Paper",
    domain: "Medical Device",
    venue: "CATT Technical Report",
    citation: "CATT (2022). Building a use-error taxonomy for AI-enabled diagnostics. CATT TR-2022-04.",
    citation_ko: "CATT (2022). AI 기반 진단의 사용 오류 분류체계 구축. CATT TR-2022-04.",
    title: "Use-Error Taxonomy for AI-Enabled Diagnostics",
    title_ko: "AI 기반 진단의 사용 오류 분류체계",
    url: "#",
  },
];
